import { render, staticRenderFns } from "./TratativasSemTratamentoComponent.vue?vue&type=template&id=d1b1de18"
import script from "./TratativasSemTratamentoComponent.vue?vue&type=script&lang=js"
export * from "./TratativasSemTratamentoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports